import React from 'react';

export type KanBanDragLock = {
    /** True while a Kanban drag is in progress — consumers should freeze list layout. */
    isDragging: boolean;
    /** rbd drag type (`column` | `card`) while dragging, else null. */
    dragType: string | null;
};

export const KanBanDragLockContext = React.createContext<KanBanDragLock>({
    isDragging: false,
    dragType: null,
});
